
import React from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style';

const Container = styled.div`
  background: white;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.05);
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  margin: 10px 20px;
  padding: 10px;

  @media(max-width: ${device.tablet}) {
    background: transparent;
    box-shadow: none;
  }
`;

export default ({ className, ...rest }) => <Container className={className} {...rest} />;
